import { FunctionsError } from "firebase/functions";

export type SignInMethod = "phone" | "email";

/**
 * `user-signup` refused because this phone/email is already on a profile that
 * another login owns. `api.signup` has already signed the stray login out; the
 * caller sends the customer to sign in the way `signInWith` says.
 */
export interface AccountConflict {
  message: string;
  signInWith: SignInMethod;
}

export const getAccountConflict = (e: unknown): AccountConflict | null => {
  const err = e as FunctionsError;
  if (err?.code !== "functions/already-exists") return null;
  const { signInWith } = err.details as { signInWith: SignInMethod };
  return { message: err.message, signInWith };
};
